'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _Filter = require('@vezeeta/enterprise-utils/lib/Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _Clinics = require('@vezeeta/enterprise-utils/lib/Clinics');

var _Clinics2 = _interopRequireDefault(_Clinics);

var _room = require('../actions/room');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(filterWorkingHours),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getRoomDetails),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(roomSaga);

function filterWorkingHours(action) {
  var allShifts;
  return _regenerator2.default.wrap(function filterWorkingHours$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _Filter2.default.filterClinics(action.days, action.filterData);

        case 2:
          allShifts = _context.sent;
          _context.next = 5;
          return (0, _effects.put)({ type: _room.ROOM.FILTER_SUCCESS, allShifts: allShifts });

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getRoomDetails(action) {
  var apiScheduleTypes, apiReservationWindow, clinicsData, accountKey, apiBody, apiCalls, apiResponses, scheduleTypes;
  return _regenerator2.default.wrap(function getRoomDetails$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          apiScheduleTypes = new _webSso.AuthApi();
          apiReservationWindow = new _webSso.AuthApi();
          clinicsData = _Clinics2.default.flattenClinics(action.clinics);
          accountKey = void 0;
          apiBody = [];


          if (action.loadAllDoctors) {
            // Should get working Hours for all doctors and rooms
            clinicsData.rooms.forEach(function (room) {
              room.Doctors.forEach(function (doctor) {
                return apiBody.push({
                  AccountKey: doctor.AccountKey,
                  RoomKey: room.RoomKey
                });
              });
            });
          } else {
            // To maintain backward compatibility with old working hours
            accountKey = clinicsData.doctors[0].AccountKey;
            apiBody = clinicsData.rooms.map(function (room) {
              return {
                AccountKey: accountKey,
                RoomKey: room.RoomKey
              };
            });
          }

          apiCalls = [{ call: apiScheduleTypes, url: _webUtils.Urls.getScheduleTypes }, { call: apiReservationWindow, url: _webUtils.Urls.getAllowReservationWindow }];
          _context2.next = 9;
          return apiCalls.map(function (apiCall) {
            return apiCall.call.post(apiCall.url, apiBody);
          });

        case 9:
          apiResponses = _context2.sent;

          if (!(_webUtils.STATUS.isSuccess(apiResponses[0].status) && _webUtils.STATUS.isSuccess(apiResponses[1].status))) {
            _context2.next = 17;
            break;
          }

          scheduleTypes = [];

          apiBody.forEach(function (doctorAndRoom, index) {
            var scheduleType = apiResponses[0].data[index];
            scheduleType.RoomKey = doctorAndRoom.RoomKey;
            scheduleTypes.push(scheduleType);
          });

          _context2.next = 15;
          return (0, _effects.put)((0, _room.getRoomDetailsSuccess)(scheduleTypes, apiResponses[1]));

        case 15:
          _context2.next = 19;
          break;

        case 17:
          _context2.next = 19;
          return (0, _effects.put)((0, _room.getRoomDetailsFail)('Failed to load room details'));

        case 19:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function roomSaga() {
  return _regenerator2.default.wrap(function roomSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_room.ROOM.FILTER, filterWorkingHours);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_room.ROOM.GET_ROOM_DETAILS, getRoomDetails);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = roomSaga;
module.exports = exports['default'];